import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueModal from 'vue-js-modal'
import App from './App.vue'
import store from './store'
import './global.exports'

import VueSocketIOExt from 'vue-socket.io-extended';
import socketIOInstance from "libs/socketIO/socketIO";

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(VueModal, {dynamic: true, dialog: true});
Vue.use(VueSocketIOExt, socketIOInstance, {store});

let options = {
    theme: {
        dark: true
    },
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    }
};

export default new Vue({
    store,
    vuetify: new Vuetify(options),
    render: h => h(App),
}).$mount('#infest-app');